import { format, subDays } from 'date-fns';
import { type DateRange } from 'react-day-picker';

import { type AttendanceReportRangeParams } from '~entities/student/api/reporting-attendance-report.types';

const CALENDAR_DATE_PATTERN = /^(\d{2})\/(\d{2})\/(\d{4})$/;

/** Inclusive days in the default absence range (today plus 29 prior days). */
export const ABSENCE_RANGE_DEFAULT_DAYS = 29;

export function defaultAbsenceDateRange(now: Date = new Date()): DateRange {
  return {
    from: subDays(now, ABSENCE_RANGE_DEFAULT_DAYS),
    to: now,
  };
}

export function toAttendanceReportRangeParams(
  date: DateRange | undefined,
): AttendanceReportRangeParams {
  return {
    startDate: date?.from ? format(date.from, 'yyyy-MM-dd') : '',
    endDate: date?.to ? format(date.to, 'yyyy-MM-dd') : '',
  };
}

export function calendarDateSortKey(value: string): string {
  const match = CALENDAR_DATE_PATTERN.exec(value.trim());
  if (!match) {
    return '';
  }
  return `${match[3]}-${match[1]}-${match[2]}`;
}

export function compareReportCalendarDates(
  left: string,
  right: string,
): number {
  return calendarDateSortKey(left).localeCompare(calendarDateSortKey(right));
}
